import iClinicApi from 'services/iclinic/iClinicApi';

export const deletePhysician = (physicianId: number, key: string) =>
  iClinicApi.delete(`/accounts/physician/${physicianId}/?key=${key}`);
